import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/baseUi/dialog"
import { WarningHexagonalIcon } from "@images/svgIcons/warningIcon"
import { word } from "@modules/core/utils/i18n"
import { useStripeConnectInstance } from "@modules/finances/taxes/hooks/useStripeConnect"
import { useTaxes } from "@modules/finances/taxes/hooks/useTaxes"
import { ConnectComponentsProvider, ConnectTaxRegistrations } from "@stripe/react-connect-js"
import { LoaderCircle } from "lucide-react"
import { useEffect, useState } from "react"
import { Text } from "@/components/ui/baseUi/text"

export function TaxSettingsDialog() {
  const stripeConnectInstance = useStripeConnectInstance()
  const [initializing, setInitializing] = useState(true)
  const { taxSettingsDialogVisible, isPendingTaxRegistrationToken, setTaxSettingsDialogVisible } = useTaxes()

  useEffect(() => {
    if (taxSettingsDialogVisible && !isPendingTaxRegistrationToken) {
      setTimeout(() => setInitializing(false), 2000)
    }
    if (!taxSettingsDialogVisible) {
      setInitializing(true)
    }
  }, [taxSettingsDialogVisible, isPendingTaxRegistrationToken])

  return (
    <Dialog open={taxSettingsDialogVisible} onOpenChange={setTaxSettingsDialogVisible}>
      <DialogContent className="h-175 w-175 p-0">
        <DialogHeader>
          <DialogTitle
            className="flex items-center justify-start border-b border-neutral-200 p-6"
            style={{ height: 70 }}
          >
            <Text fontStyle="TL">{word("finances.taxes.dialog.registration.title")}</Text>
          </DialogTitle>
        </DialogHeader>

        <div
          className="relative mx-2 my-4 flex w-fit flex-col items-start justify-start gap-2 overflow-hidden"
          style={{ height: "calc(100% - 70px)" }}
        >
          {initializing && (
            <div className="absolute z-5 flex h-full w-full items-center justify-center bg-surface-background">
              <LoaderCircle className="size-6 animate-spin" />
            </div>
          )}
          <div className="flex flex-row items-center gap-3 rounded-md bg-(--card-background) p-3">
            <div className="flex">
              <WarningHexagonalIcon color={"var(--primary-300)"} width={18} height={18} />
            </div>
            <Text fontStyle="BM">{word("finances.taxes.dialog.activate.informations")}</Text>
          </div>
          {stripeConnectInstance && (
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
              <ConnectTaxRegistrations />
            </ConnectComponentsProvider>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
